export default __webpack_public_path__ + "static/media/SIGLE-PIINKFLOW.33975073.png";